import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function HotArticlesSection() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 4);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              热门文章推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-600 font-body">
              粉丝最爱的深度解析内容
            </p>
          </div>
          <Link
            to="/category/plot-analysis"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-body text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {hotArticles.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}